module.exports = __webpack_public_path__ + "static/media/lyretail_anthias.9ef5a0fd.svg";